/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum QuoteGenerationMethod {
  Manual = "manual",
  Ratesheet = "ratesheet",
  Api = "api",
  Scraping = "scraping",
}

export function instanceOfQuoteGenerationMethod(value: any): boolean {
  for (const key in QuoteGenerationMethod) {
    if (Object.prototype.hasOwnProperty.call(QuoteGenerationMethod, key)) {
      if (
        QuoteGenerationMethod[key as keyof typeof QuoteGenerationMethod] ===
        value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function QuoteGenerationMethodFromJSON(
  json: any,
): QuoteGenerationMethod {
  return QuoteGenerationMethodFromJSONTyped(json, false);
}

export function QuoteGenerationMethodFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): QuoteGenerationMethod {
  return json as QuoteGenerationMethod;
}

export function QuoteGenerationMethodToJSON(
  value?: QuoteGenerationMethod | null,
): any {
  return value as any;
}

export function QuoteGenerationMethodToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): QuoteGenerationMethod {
  return value as QuoteGenerationMethod;
}
